import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter as Router, Routes, Route } from "react-router";
import './styles/main.scss'
import Home from "./pages/Home";
import Quiz from "./pages/Quiz";
import Question from "./pages/Question";
import Result from "./pages/Result";
import APropos from "./pages/APropos";
import ScrollToTop from "./utils/ScrollToTop";
import Layout from "./components/Layout/Layout";

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
    <Router>
        <StrictMode>
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route index path="/" element={<Home />} />
                    <Route path="/quiz" element={<Quiz />}>
                        <Route index path=":qid" element={<Question />} />
                        <Route path="result" element={<Result />} />
                    </Route>
                    <Route path="/a-propos" element={<APropos />} />
                </Routes>
            </Layout>
        </StrictMode>
    </Router>
);
